import { render, staticRenderFns } from "./Motivation.vue?vue&type=template&id=6cc3b356"
import script from "./Motivation.vue?vue&type=script&lang=js"
export * from "./Motivation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports